// extracted by mini-css-extract-plugin
export var certificate = "education-module--certificate--06637";
export var description = "education-module--description--46113";
export var education = "education-module--education--6bc7f";